import { AxiosError, AxiosResponse, Method } from 'axios'

import { http } from './http'
import { getClientTimeZone } from '../../utils/date-time'
import { env } from '../../utils/env'

type Request = <D = any>(
  method: Method,
  url: string,
  data?: FormData | object,
  params?: Record<string, any>,
  headers?: Record<string, any>,
  signal?: AbortSignal,
) => Promise<AxiosResponse<D>>

const addVersionToUrl = (url: string): string => {
  const urlArr = url.split('/').filter((part: string) => !!part)

  return ['', env('API_VERSION'), ...urlArr].join('/')
}

const checkEndSlash = (url: string): string => {
  if (url.endsWith('/')) {
    return url
  }

  return url.concat('/')
}

export const Request: Request = async (method, urlPath, data, params, headers, signal) => {
  try {
    const urlWithVersion = addVersionToUrl(String(urlPath))
    let url = urlPath
    if (!urlPath.startsWith('http')) {
      url = checkEndSlash(urlWithVersion)
    }

    return await http({
      method,
      url,
      data,
      params,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
        timezone: getClientTimeZone(),
      },
      signal,
    })
  } catch (e) {
    throw e as AxiosError
  }
}

export const downloadFile = async (method: Method, urlPath: string, data: Record<string, any> = {}) => {
  const urlWithVersion = addVersionToUrl(urlPath)
  const url = checkEndSlash(urlWithVersion)

  const response = await http({
    method,
    url,
    data,
    withCredentials: true,
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  })

  const contentDisposition = response.headers['content-disposition']

  let filename = 'report.xlsx'
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i) || contentDisposition.match(/filename="?([^";]+)"?/i)
    if (filenameMatch && filenameMatch[1]) {
      filename = decodeURIComponent(filenameMatch[1])
    }
  }

  const downloadUrl = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = downloadUrl
  a.download = filename
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(downloadUrl)
}
